import {
  AfterContentInit,
  Component,
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

import { NgslCarouselItemDirective } from './ngsl-carousel-item.directive';
import { NgslCarouselDotDirective } from './ngsl-carousel-dot.directive';
import {
  animate,
  AnimationBuilder,
  AnimationFactory,
  AnimationPlayer,
  style
} from '@angular/animations';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '.ngsl-carousel-item-directive'
})
// tslint:disable-next-line:directive-class-suffix
export class CarouselItemElement {}
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '.ngsl-carousel-dot-directive'
})
// tslint:disable-next-line:directive-class-suffix
export class CarouselDotElement {}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngsl-carousel',
  exportAs: 'ngsl-carousel',
  templateUrl: './ngsl-carousel.component.html',
  styleUrls: ['./ngsl-carousel.component.scss']
})
export class NgslCarouselComponent implements AfterContentInit {
  /* carousel start item */
  @ContentChildren(NgslCarouselItemDirective) items: QueryList<NgslCarouselItemDirective>;
  @ViewChildren(CarouselItemElement, { read: ElementRef }) private itemsElements: QueryList<ElementRef>;
  @ViewChild('track') private carousel: ElementRef;
  /* carousel end item */

  /* carousel start dot */
  @ContentChildren(NgslCarouselDotDirective) dotsList: QueryList<NgslCarouselDotDirective>;
  @ViewChildren(CarouselDotElement, { read: ElementRef }) private dotElements: QueryList<ElementRef>;
  @ViewChild('dotTrack') private dotTrack: ElementRef;
  /* carousel end dot */

  /* Input props start*/
  @Input() timing = 450;
  @Input() rewindTiming = 900;
  @Input() arrows = true;
  @Input() dots = true;
  @Input() infinity = true;
  @Input() dynamicTiming = false;
  @Input() autoplay = true;
  @Input() perView = 1;
  /* Input props end*/
  private player: AnimationPlayer;
  private action = null;
  currentSlide = 0;
  prevSlide = null;
  nextSlide = null;
  trackWidth = {};

  private buildAnimation(offset) {
    const duration = this.action === 'REWIND' ? this.rewindTiming : this.timing;
    return this.builder.build([
      animate(`${duration}ms cubic-bezier(0.165, 0.840, 0.440, 1.000)`, style({ transform: `translateX(${offset}%)` }))
    ]);
  }

  private changeSlide(action) {
    this.setSlidesIndex();
    const itemW = (100 / this.items.length) / this.perView;
    const offset = (itemW * this.currentSlide) * this.perView;
    const myAnimation: AnimationFactory = this.buildAnimation(-offset);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();
    // console.log(`changeSlide action: ${action}, is current slide: `, this.currentSlide + 1);
  }

  goToSlide(index) {
    if (this.dynamicTiming) {
      // Ð ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÐºÐµ, ÑÐµÑÑÐ¾Ð²Ð°Ñ Ð¾Ð¿ÑÐ¸Ñ
      this.timing = this.timing + (55 * (index - this.currentSlide));
    }
    this.currentSlide = index;
    this.changeSlide('go to slide');
  }

  next() {
    const countSlides = this.items.length;
    if (this.currentSlide + 1 === countSlides && this.infinity) {
      this.currentSlide = 0;
      this.action = 'REWIND';
      this.changeSlide('rewind to first slide');
      return;
    }
    if (this.currentSlide + 1 === countSlides && !this.infinity) {
      return;
    }

    this.currentSlide++;
    this.action = 'NEXT_SLIDE';
    this.changeSlide('next slide');
  }

  prev() {
    const countSlides = this.items.length;
    if (this.currentSlide === 0 && this.infinity) {
      this.currentSlide = countSlides - 1;
      this.action = 'REWIND';
      this.changeSlide('rewind to last slide');
      return;
    }
    if (this.currentSlide === 0 && !this.infinity) {
      return;
    }

    this.currentSlide--;
    this.action = 'PREV_SLIDE';
    this.changeSlide('prev slide');
  }

  private setSlidesIndex() {
    this.prevSlide = this.currentSlide === 0 ? this.items.length - 1 : this.currentSlide - 1;
    this.nextSlide = this.currentSlide === this.items.length - 1 ? 0 : this.currentSlide + 1;
  }

  private removeDotsInDomElements() {
    const position = this.perView > 1 ? this.dotsList.length - this.perView : null;
    this.dotsList.toArray().forEach((dot, i) => {
      if (i > position) { dot.isVisible = false; }
    });
  }

  private setInitValues() {
    this.setSlidesIndex();
    if (this.perView > 1) {
      this.removeDotsInDomElements();
    }
    this.trackWidth = {
      width: `${(100 * this.items.length) / this.perView}%`
    };
  }

  constructor(private builder: AnimationBuilder) {}

  ngAfterContentInit() {
    this.setInitValues();
  }
}
